/* import __COLOCATED_TEMPLATE__ from './audio-device-info.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import type TwilioService from 'embercom/services/twilio-service';
import type IntlService from 'embercom/services/intl';

interface Signature {
  Args: {
    // No arguments needed - component will get device info from service
  };
  Element: HTMLDivElement;
}

export default class AudioDeviceInfo extends Component<Signature> {
  @service declare twilioService: TwilioService;
  @service declare intl: IntlService;

  @tracked audioDevices: {
    microphone: string | null;
    speaker: string | null;
  } = { microphone: null, speaker: null };

  @tracked isLoading = true;

  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);
    this.loadAudioDevices();
  }

  async loadAudioDevices() {
    try {
      this.isLoading = true;
      this.audioDevices = await this.twilioService.getAudioDevices();
    } catch (error) {
      console.error('Failed to load audio devices:', error);
      this.audioDevices = { microphone: null, speaker: null };
    } finally {
      this.isLoading = false;
    }
  }

  get microphoneDisplayName() {
    if (this.isLoading) {
      return this.intl.t('calling.audio-devices.microphone');
    }
    return this.audioDevices.microphone || this.intl.t('calling.audio-devices.no-device');
  }

  get speakerDisplayName() {
    if (this.isLoading) {
      return this.intl.t('calling.audio-devices.speaker');
    }
    return this.audioDevices.speaker || this.intl.t('calling.audio-devices.no-device');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Calling::AudioDeviceInfo': typeof AudioDeviceInfo;
    'inbox2/calling/audio-device-info': typeof AudioDeviceInfo;
  }
}
